// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__1wMY8","title":"AfterImages90_title__3XBk6","images":"AfterImages90_images__3-5F4"};